import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core"; 
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"; 
import { UnitCreationComponent } from "./units-creation/units-creation.component";
import { UnitEditComponent } from "./units-edit/units-edit.component";
import { Unit, VIKUnitClient } from "../../../../../web-api-client";
import { UnSuccessModalComponent } from "../../../../../modals/failed-modal/failed-modal.component";
import { SuccessModalComponent } from "../../../../../modals/success-modal/success-modal.component";
import { ConfirmModalComponent } from "../../../../../modals/confirm-modal/confirm-modal.component";


@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class UnitsComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedObject: Unit;
  public allObjects: Unit[];

  // Assuming you already have a property for all the objects
  searchQuery: string = '';
  filteredObjects: Unit[] = [];




  constructor(private readonly changeDetectionRef:ChangeDetectorRef, private readonly modalService: NgbModal,public client:VIKUnitClient){

  }

  ngOnInit(): void {

    this.loadData();

  }


  public filterObjects() {
    if (this.searchQuery) {
      this.filteredObjects = this.allObjects.filter(object =>
        object.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredObjects = this.allObjects;
    }
  }

  public loadData() {
        this.client.getList().subscribe((allObjects: Unit[]) => {
          this.allObjects = allObjects;
          this.filteredObjects = allObjects;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
    }

 public onSelected(object:Unit){
   if (this.isSelected(object)){
    this.selectedObject = null;
  }
  else{

     this.selectedObject = object;
  }
 }

  public isSelected(object:Unit):boolean{
    return this.selectedObject == object;
 }

public onCreation():void{
  let modalRef = this.modalService.open(UnitCreationComponent, {});

  modalRef.componentInstance.onClose.subscribe(r => {

    this.loadData();

  });

}


public onDelete(): void {


    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedObject.id).subscribe(r => {
          this.allObjects = this.allObjects.filter(d => d.id != this.selectedObject.id);
          this.filteredObjects = this.allObjects.slice(0);
          this.changeDetectionRef.detectChanges();
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(UnitEditComponent);
    modalRef.componentInstance.editObject = this.selectedObject;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();

    });

    }

}
